/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeregisterTokenRequest } from '../models/DeregisterTokenRequest';
import type { RegisterTokenRequest } from '../models/RegisterTokenRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TokenControllerService {

    /**
     * Registers a push notification token.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static registerToken(
        requestBody: RegisterTokenRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/push/tokens/register',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

    /**
     * De-registers a push notification token.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static deregisterToken(
        requestBody: DeregisterTokenRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/push/tokens/deregister',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

}
